import { Button, Col, Form, Modal, Row, Spinner, } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { fetchOtp, resetError, resetStatus, updateEmail, verifyDetails, verifyEmail } from "../store/userProfileSlice";
import { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import LoadingSpinner from "../../shared/components/LoadingSpinner";

const UserEmailModal = ({ show, setShow }) => {
    const dispatch = useDispatch();
    const profileDetails = useSelector((state) => state?.userProfile);
    const { status, error, otpMessage, otpStatus, data, errorStatus, loading } =
        useSelector((state) => state?.userProfile);

    const [otpShow, setOtpShow] = useState(false);
    const [otp, setOtp] = useState({ value: '' });


    useEffect(() => {
        dispatch(updateEmail(data?.email));
    }, []);

    useEffect(() => {
        if (errorStatus) {
            toast.error("Error while changing the email. Please try again later.");
            setOtpShow(false);
            dispatch(resetError());
        }
    }, [errorStatus, dispatch]);

    useEffect(() => {
        if (otpStatus) {
            toast.success(otpMessage);
            setOtpShow(true);
            dispatch(resetStatus())
        }
    }, [otpStatus, otpMessage]);

    const handleVerify = () => {
        if (!otp || otp.length < 6) {
            toast.error("Please enter OTP")

        } else {
            const payload = {
                email: profileDetails?.email,
                old_phone: profileDetails?.phone,
                user_otp: otp,
            };
            dispatch(verifyEmail(payload));
        }
    };

    const handleSubmit = () => {
        if (!profileDetails?.email) {
            toast.error("Please enter email");
            return;
        }

        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        if (!emailPattern.test(profileDetails?.email)) {
            toast.error("Please enter a valid email address");
            return;
        }
        const payload = {
            email: profileDetails?.email,
            old_phone: profileDetails?.phone,
        };
        dispatch(fetchOtp(payload));
    };

    return (
        <>
            <ToastContainer />
            <Modal show={show} centered size="md" onHide={() => setShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Email</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col lg={12}>
                            <Form.Control
                                type="email"
                                name="email"
                                value={profileDetails?.email}
                                placeholder="Enter Your Email"
                                onChange={(e) => {
                                    dispatch(updateEmail(e.target.value));
                                }}
                            />
                        </Col>
                    </Row>
                    {otpShow && (
                        <Row className="d-flex mt-5 justify-content-start align-items-center">
                            <Col lg={12}>
                                <Form.Label>Enter OTP</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="otp"
                                    pattern="[0-9]*"
                                    minLength={6}
                                    maxLength={6}
                                    value={otp?.value}
                                    onChange={(e) => setOtp(e.target.value)}
                                    autoFocus
                                />
                            </Col>
                        </Row>
                    )}
                </Modal.Body>
                <Modal.Footer style={{ borderTop: '1px solid lightgray' }}>
                    {!otpShow && (
                        <Row className="py-1">
                            <Col lg={12}>
                                <Button onClick={handleSubmit}>Get OTP</Button>
                            </Col>
                        </Row>
                    )}
                    {otpShow && (
                        <Row className="py-1">
                            <Col lg={12}>
                                <Button className="mx-2" onClick={handleVerify}>
                                    Verify
                                </Button>
                                <Button
                                    className="mx-2"
                                    variant="outline-secondary"
                                    onClick={() => {
                                        setOtpShow(false);
                                        setShow(false);
                                    }}
                                >
                                    Cancel
                                </Button>
                            </Col>
                        </Row>
                    )}
                </Modal.Footer>
                {loading && <LoadingSpinner />}
            </Modal>
        </>
    );
};

export default UserEmailModal;
